var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-view',{attrs:{"hide-navigation":""}},[_c('projects-section',[_c('projects-list',{attrs:{"items":_vm.projectItems,"visible":_vm.visible},on:{"transitionEnd":_vm.setProjects}})],1),_vm._v(" "),_c('in-viewport',[_c('projects-pagination-container')],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03cc7310","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Projects/ProjectsContainer.vue
// module id = null
// module chunks = 